export const worklistCopyEs = {
    worklist: "Lista de tareas",
    yourTasks: "Sus tareas",
    description:
        "Complete los formularios del clínico, los consentimientos y la información que falta sobre el evento para todos sus pacientes.",
    emptyTitle: "Está al día",
    emptyDescription: "Ninguna tarea del clínico pendiente por el momento.",
    noMatchingTasks: "Ninguna tarea coincidente",
    noMatchingTasksDescription: "Pruebe a modificar la búsqueda, la pestaña o los filtros.",
    complete: "Completar",
    completeDetails: "Completar la información",
    completeDetailsPanelDescription:
        "Introduzca la información que falta y, a continuación, vuelva a su lista de tareas.",
    signConsent: "Firmar el consentimiento",
    closePanel: "Cerrar el panel",
    noTaskSelected: "Seleccione una tarea",
    noTaskSelectedDescription:
        "Elija una fila para completar aquí un formulario, un consentimiento o información que falta sobre el evento.",
    openDiary: "Abrir el diario",
    openPatient: "Abrir el paciente",
    toDo: "Pendiente",
    refresh: "Actualizar",
    forms: "Formularios",
    details: "Información",
    archived: "Archivadas",
    archive: "Archivar",
    archiveAll: "Archivar todo",
    restoreAll: "Restaurar todo",
    tasksSelected: (count: number) => (count === 1 ? "1 tarea seleccionada" : `${count} tareas seleccionadas`),
    selectedTasksDescription: "Elija una acción para las tareas seleccionadas.",
    selectTask: "Seleccionar la tarea",
    selectAllTasks: "Seleccionar todas las tareas",
    restore: "Restaurar",
    archiveSucceeded: (count: number) => (count === 1 ? "Tarea archivada." : `${count} tareas archivadas.`),
    archiveFailed: "No se ha podido archivar esta tarea. Inténtelo de nuevo.",
    restoreSucceeded: (count: number) => (count === 1 ? "Tarea restaurada." : `${count} tareas restauradas.`),
    restoreFailed: "No se ha podido restaurar esta tarea. Inténtelo de nuevo.",
    emptyArchivedTitle: "Nada archivado",
    emptyArchivedDescription: "Las tareas que archive permanecen aquí hasta que las restaure.",
    allPeople: "Todas las personas",
    peopleFilterLabel: "Personas",
    selectPeople: "Seleccionar los clínicos",
    organisationFilterLabel: "Organización",
    allOrganisations: "Todas las organizaciones",
    taskTypeFilterLabel: "Tipo de tarea",
    allTaskTypes: "Todos los tipos de tarea",
    searchTasks: "Buscar tareas",
    clearSearch: "Borrar la búsqueda de tareas",
    filterTasks: "Filtrar las tareas",
    filterTasksDescription: "Elija las personas, la organización y el tipo de tarea.",
    taskCompleteTitle: "Tarea guardada",
    taskCompleteDescription: "Pase a la siguiente persona de su lista de tareas cuando lo desee.",
    taskCompleteAllDoneTitle: "Todo completado",
    taskCompleteAllDoneDescription: "No quedan tareas en esta lista.",
    continueToNextTask: "Pasar a la siguiente tarea",
    doNext: "Por hacer a continuación",
    doNextDescription: (task: string, patientName: string, hospitalNumber: string | null) =>
        hospitalNumber
            ? `${task} para ${patientName}. Número de historia clínica: ${hospitalNumber}`
            : `${task} para ${patientName}`,
    nextPatientTask: (name: string) => `Siguiente: ${name}`,
    returnToWorklist: "Volver a la lista de tareas",
    patient: "Paciente",
    hospitalNumber: "Número de historia clínica",
    task: "Tarea",
    injectionDetailsTask: "Información sobre la inyección",
    surgeryDetailsTask: "Información sobre la cirugía",
    shockwaveDetailsTask: "Información sobre las ondas de choque",
    procedureDetailsTask: "Información sobre la intervención",
    consentTask: "Consentimiento",
    due: "Vencimiento",
    status: "Estado",
    actions: "Acciones",
    dueLabel: "Pendiente",
    blockedLabel: "Bloqueada",
    incompleteLabel: "Incompleta",
    blockedBy: (blocker: string) => `Complete primero: ${blocker}`,
    truncatedNotice: (total: number, shown: number) =>
        `Se muestran los primeros ${shown} diarios de ${total} que incluyen formularios del clínico. Restrinja su lista de pacientes para ver los demás.`,
    unknownPatient: "Paciente desconocido",
    notDefined: "Sin definir",
    loading: "Cargando la lista de tareas…",
    errorLoading: (message: string) => `No se ha podido cargar la lista de tareas: ${message}`,
    taskCount: (count: number) => (count === 1 ? "1 tarea" : `${count} tareas`),
};
